import PropTypes from 'prop-types';
import React from 'react';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';

const ArtistBio = props => {
  const { pandoraId, bio, shareableUrlPath, isMobileDevice, shortTextWidthRatio } = props;

  if (!bio) return null;

  const linkUrl = shareableUrlPath
    ? D.getBackstageArtistFullBioPathForShareUrl(shareableUrlPath)
    : null;

  return (
    <D.ContentSection isBio={true}>
      <D.DescriptionBackstageWithLogger
        text={bio}
        linkUrl={linkUrl}
        pandoraId={pandoraId}
        linkText={BackstageConstants.messages.readMore}
        disableHover={isMobileDevice}
        isExpanded={false}
        shortTextWidthRatio={shortTextWidthRatio}
      />
    </D.ContentSection>
  );
};

ArtistBio.propTypes = {
  pandoraId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  bio: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  shortTextWidthRatio: PropTypes.number,
};

export default ArtistBio;
